import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery, AppBar, Toolbar  } from '@material-ui/core';

import GDPR from '../../components/GDPR';
import { Footer } from './components';

import './css/style.css'

import { LOGO_ONLY as theLogo } from '../../constants';


const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '90vh',
  },
  appBar: {
    //   minHeight: 160,
      background: 'white',
      display: 'block'
  },
  toolBarCenter: {
      width: 'fit-content',
      margin: 'auto',
  },

  menuButton: {
  },
//   shiftContent: {
//     paddingLeft: 75
//   },
  content: {
    // height: '100%',
    minHeight: '90vh'
  },
}));

const Visitor = props => {
  const { children, user } = props;

  const classes = useStyles();
  const theme = useTheme();
//   const isDesktop = useMediaQuery(300, {
//     defaultMatches: true
//   });
  const isDesktop = false;

  const [openSidebar, setOpenSidebar] = useState(false);
  const [anchorEl, setAnchor] = useState(null);


  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = openSidebar;

  const handleMenuClick = (e) => {
    setAnchor(e.currentTarget);
  }

  const handleMenuClose = () => {
    setAnchor(null);
}

  return (
    <div
      id="main-layout"
      className={clsx({
        [classes.root]: true,
      })}
    >
          <AppBar color="default" className={classes.appBar} >
              <Toolbar className={classes.toolBarCenter}>
              <a href='/'>
                    <img src={theLogo} alt="Understanding Ag, LLC" className='company-logo' width='150' />
                    </a>
                    <div style={{marginTop: 30, color: '#623b17', marginLeft: 2, fontSize: 18, fontWeight: 500}}>
                    Understanding<span style={{fontWeight: 'bold'}}>AG</span>&nbsp;&nbsp;Regen Ag Online Series Portal
                    </div>

              </Toolbar>
              <Toolbar className={'toolBarNav'} >
                  <a href='/' className={'portal-nav-link'}>
                      HOME
                  </a>
              </Toolbar>
          </AppBar>
      <main className={classes.content}>
        {children}
      </main>
      <GDPR />
      <Footer />
     

    </div>
  );
};

Visitor.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object
};

export default Visitor;
